import { render, staticRenderFns } from "./FrameType.vue?vue&type=template&id=2d004aad&"
import script from "./FrameType.vue?vue&type=script&lang=js&"
export * from "./FrameType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports